import { useApiContext } from 'react-easyrocket';
import { useNavigate } from 'react-router';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { useRoute } from 'src/router/hooks/useRoute';

export const OpenRegistrationByUrl = () => {
  const { ROUTE } = useRoute();
  const { isAuthenticated } = useApiContext();
  const navigate = useNavigate();
  const { startRegistration } = useAuthFlow();

  if (!isAuthenticated) {
    startRegistration({ replace: true });
  }

  navigate(ROUTE.GAMES.get('top'));
  return <></>;
};
